import React, { useEffect, useLayoutEffect, useState } from "react";
import JackpotGameBonus from "./JackpotGameBonus";
import YouWin, { preloadYouWin, youWinPaidAt, YOU_WIN_MS } from "./YouWin";
import DoubleUp from "./DoubleUp";
import LuckyWheelBonus from "./LuckyWheelBonus";
import { TvButton } from "../wrapper/TvMillionarioGame";
import "./TvMillionario.css";

const FOOT = `${process.env.PUBLIC_URL}/tv-milionario/footer-buttons`;
const MSG = { double: "msg_double", major_minor: "msg_major_minor", win: "msg_win", pierde: "msg_pierde", press_init: "msg_press_init", bonus: "msg_bonus", congrats: "msg_congrats" };

// ?double=2400: the DOBLAR card screen on its own, over a bare footer that
// shows its message and GANA (as text). Deals again when it ends.
const DoublePreview = ({ amount }) => {
    const [round, setRound] = useState(0);
    const [gana, setGana] = useState(amount);
    const [msg, setMsg] = useState("major_minor");
    return (
        <>
            <img alt="" src={`${FOOT}/panel.png`} style={{ position: "absolute", left: 22, top: 492, width: 756, height: 108 }} />
            <div className="tvm-msg" style={{ left: 72 }}><img alt="" src={`${FOOT}/${MSG[msg] || MSG.win}.png`} /></div>
            <div style={{ position: "absolute", right: 60, top: 519, color: "#7fd8ff", font: "bold 16px Arial" }}>{gana}</div>
            <DoubleUp key={round} amount={amount} Button={TvButton} keyboardInput onAmount={setGana} onMessage={setMsg}
                onDone={(paid) => { setMsg(paid > 0 ? "win" : "pierde"); setTimeout(() => { setGana(amount); setRound((r) => r + 1); }, 1500); }} />
        </>
    );
};

// ?wheel=60000: the LUCKY WHEEL on its own, over the same bare footer.
const WheelPreview = ({ pot }) => {
    const [round, setRound] = useState(0);
    const [gana, setGana] = useState(0);
    const [msg, setMsg] = useState("press_init");
    return (
        <>
            <img alt="" src={`${FOOT}/panel.png`} style={{ position: "absolute", left: 22, top: 492, width: 756, height: 108 }} />
            <div className="tvm-msg" style={{ left: 72 }}><img alt="" src={`${FOOT}/${MSG[msg] || MSG.win}.png`} /></div>
            <div style={{ position: "absolute", right: 60, top: 519, color: "#7fd8ff", font: "bold 16px Arial" }}>{gana}</div>
            <LuckyWheelBonus key={round} gameResult={{ bonusType: "Preview" }} keyboardInput testPot={pot} Button={TvButton}
                onGana={setGana} onMessage={setMsg} onDone={() => setTimeout(() => { setGana(0); setRound((r) => r + 1); }, 1500)} />
        </>
    );
};

// DEV ONLY (/tv-jackpot-bonus): the JACKPOT GAME bonus and the YOU WIN that
// follows it, on their own, on the same scaled 800x600 stage as the TV game,
// with a made-up payout and no login or server. Then it starts again.
// ?amount=0 tries the "EXIT at once" round; ?youwin=1 starts on YOU WIN.
const params = new URLSearchParams(window.location.search);
const AMOUNT = Number(params.get("amount") ?? 41000);

const JackpotGamePreview = () => {
    const [round, setRound] = useState(0);
    const [youWin, setYouWin] = useState(params.get("youwin") ? AMOUNT : null);
    const fit = () => ({ x: window.innerWidth / 800, y: window.innerHeight / 600 });
    const [scale, setScale] = useState(fit);
    useLayoutEffect(() => {
        const onResize = () => setScale(fit());
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);
    useEffect(() => preloadYouWin(), []);

    // count the YOU WIN the way the game does, then go round again
    const showing = youWin !== null;
    useEffect(() => {
        if (!showing) return;
        const startedAt = Date.now();
        const id = setInterval(() => {
            const t = Date.now() - startedAt;
            if (t >= YOU_WIN_MS) {
                clearInterval(id);
                setYouWin(null);
                setRound((r) => r + 1);
                return;
            }
            setYouWin(AMOUNT - youWinPaidAt(AMOUNT, t));
        }, 33);
        return () => clearInterval(id);
    }, [showing]);

    return (
        <div className="tvm-viewport">
            <div className="tvm-stage" style={{ transform: `scale(${scale.x}, ${scale.y}) translate(-50%, -50%)` }}>
                {params.get("wheel")
                    ? <WheelPreview pot={Number(params.get("wheel")) || 60000} />
                    : params.get("double")
                    ? <DoublePreview amount={Number(params.get("double")) || 2400} />
                    : showing
                    ?<YouWin value={youWin} variant={params.get("youwin") === "girl" ? "girl" : "guy"} onSkip={() => { setYouWin(null); setRound((r) => r + 1); }} />
                    : <JackpotGameBonus key={round}
                        gameResult={{ bonusType: "Preview" }}
                        keyboardInput
                        credits={61005}
                        totalBet={1000}
                        accumulados={[160000, 80000, 40000]}
                        testPayout={AMOUNT}
                        onBonusRoundCompleted={(amount) => (amount > 0 ? setYouWin(amount) : setRound((r) => r + 1))} />}
            </div>
        </div>
    );
};

export default JackpotGamePreview;
